import ChooseSeasonTab from "./tabs/choose_season/ChooseSeasonTab";
import MergeAuditioneesTab from "./tabs/merge_auditionees/MergeAuditioneesTab";
import ClashesTab from "./tabs/clashes/ClashesTab";
import ChoicesTab from "./tabs/choices/ChoicesTab";
import { Air, People, SmartToy, TableView } from "@mui/icons-material";
import MergeAuditioneesTab2 from "./tabs/merge_auditionees_2/MergeAuditioneesTab2";

const clashBotConsoleRouter = (season, auditionees, clashBotData, register) => {

  if(season === null)
  {
    return {
      season: 
      {
        title: 'Choose Season',
        icon: <Air />,
        element: <ChooseSeasonTab />
      }
    }
  }
  else if(auditionees === null || clashBotData === null || register === null)
  {
    return {
      auditionees: 
      {
        title: 'Auditionees',
        icon: <People />,
        element: <MergeAuditioneesTab2 />
      }
    }
  }
  else
  {
    return {
      clashes: 
      {
        title: 'Clashes',
        icon: <SmartToy />,
        element: <ClashesTab />
      },

      table:
      {
        title: 'Table',
        icon: <TableView />,
        element: <ChoicesTab />
      }
    }
  }

}

export default clashBotConsoleRouter;